import { useRef, useState } from "react";
import images from "../constants/images";
import Clickable from "./clickable.";
import { pwaInstallHandler } from "pwa-install-handler";
import { useDispatch, useSelector } from "react-redux";
import { setToken } from "../redux/slices";
import { useNavigate } from "react-router-dom";

const Header = ({ title }) => {
    const [showCover, setShowCover] = useState(false);

    const menuRef = useRef();
    const dispatch = useDispatch();

    const navigate = useNavigate();

    const token = useSelector((s) => s.token.value);

    const toggleSidebar = () => {
        if (menuRef.current) {
            const left = menuRef.current.style.left.split("px")[0];
            menuRef.current.style.left =
                left && parseFloat(left) >= 0 ? "-300px" : "0px";
            setShowCover(left && parseFloat(left) >= 0 ? false : true);
        }
    };

    return (
        <>
            {showCover && <div className="cover" />}

            <div className="menu" ref={menuRef}>
                <div className="user">
                    <Clickable className="user-icon">
                        <img src={images.user} />
                    </Clickable>
                    <div className="num">
                        MO NO - {localStorage.getItem("num")}
                    </div>
                </div>

                {/* <Clickable className="style-1">
                    <img src={images.info} className="info-icon" />
                    About
                </Clickable> */}

                <Clickable
                    className="style-1"
                    onClick={() =>
                        navigator?.share({
                            url: "http://localhost:3000/attendance",
                        })
                    }
                >
                    <img src={images.share} className="info-icon" />
                    Share
                </Clickable>

                {/* <Clickable className="style-1">
                    <img src={images.grid} className="info-icon" />
                    App Gallery
                </Clickable> */}

                {pwaInstallHandler.canInstall() && (
                    <Clickable
                        className="style-1"
                        onClick={() => pwaInstallHandler.install()}
                    >
                        <img src={images.install} className="info-icon" />
                        Install App
                    </Clickable>
                )}

                {token && (
                    <Clickable
                        className="menu-btn"
                        onClick={() => {
                            dispatch(setToken(null));
                            navigate("/login");
                        }}
                    >
                        <div>Logout</div>
                    </Clickable>
                )}
            </div>

            <div className="header">
                <div className="style-0">
                    <Clickable
                        onClick={() => {
                            toggleSidebar(false);
                        }}
                        className="style-2"
                    >
                        <img src={images.menu} className="menu-icon" />
                    </Clickable>
                    <img
                        src={images.inspections}
                        className="inspections-icon"
                    />
                    <div className="style-14">
                        <div className="style-15">{title}</div>
                    </div>
                    <Clickable className="style-2">
                        <img src={images.add} />
                    </Clickable>
                </div>
            </div>
        </>
    );
};

export default Header;
